export const ORDER_STATE = {
    PAYMENT_SETTLED: "PaymentSettled",
    PAYMENT_AUTHORIZED: "PaymentAuthorized",
    ADDING_ITEMS: "AddingItems",
    ARRANGING_PAYMENT: "ArrangingPayment",
} as const;

export const GRAPHQL_TYPENAME = {
    ORDER: "Order",
    ORDER_PAYMENT_STATE_ERROR: "OrderPaymentStateError",
    PAYMENT_DECLINED_ERROR: "PaymentDeclinedError",
    PAYMENT_FAILED_ERROR: "PaymentFailedError",
    ORDER_STATE_TRANSITION_ERROR: "OrderStateTransitionError",
} as const;

export const REDIRECT_STATUS = {
    SUCCEEDED: "succeeded",
    BANK_TRANSFER: "bank_transfer",
} as const;

export const PAYMENT_ERROR_MESSAGES = {
    STRIPE_NOT_INITIALIZED: "Stripe not initialized properly",
    PAYMENT_FAILED: "Payment failed. Please try again.",
    STRIPE_PUBLISHABLE_KEY_NOT_CONFIGURED:
        "Stripe publishable key not configured. Please contact support.",
    UNABLE_TO_PROCEED_TO_PAYMENT: "Unable to proceed to payment",
} as const;
